import React from 'react'

function Error() {
  return (
    <div className='coupon-container'>
        <div className="coupon-card">
            <h3>Error: Page Not Found</h3>
            <p>No page found with this link. <br /> Something went wrong. Please try different link.</p>
            <p>申し訳ありませんが、このリンクでページが見つかりません。<br />何か問題が発生しました。別のリンクを試してください。</p>
        </div>
    </div>
  )
}

export default Error